module.exports = __webpack_public_path__ + "img/coupon-card@2x.e3ad0092.png";